import { ITableAction } from "../types/tableProps";
import { TableActionsInline } from "./TableActionsInline";
import { TableActionsList } from './TableActionsList';

interface IRenderActionsTable {
    tableActions: ITableAction;
    rowData: any;
}

export function TableActions({ tableActions, rowData }: IRenderActionsTable) {
    if (tableActions.actions.length == 0) return null;

    function renderActions() {

        switch (tableActions.type) {
            case "inline":
                return (
                    <TableActionsInline
                        actions={tableActions.actions}
                        rowData={rowData}
                    />
                )
            case "list":
                return (
                    <TableActionsList
                        actions={tableActions.actions}
                        rowData={rowData}
                        icon={tableActions.icon}
                        title={tableActions.name}
                    />
                )
            default:
                return (
                    <TableActionsList
                        actions={tableActions.actions}
                        rowData={rowData}
                        icon={tableActions.icon}
                        title={tableActions.name}
                    />
                )
        }

    }

    return renderActions()
}